<template>
	<div>
		<TableList :form_data_seo.sync="form_data_seo" :columns="columns" :get_table_list="this.get_table_list"
		 :slot_table_list="['operation']" :is_page="false" ref="list" rowKey="id" :submit_preprocessing="submit_preprocessing">

            <template slot="right_btn">
                <a @click="goReport()">
                    <a-button class="a_btn">导出</a-button>
                </a>
            </template>
            
			<!-- <template slot="operation" slot-scope="data">
				<a @click="see(data.record)">查看</a>
			</template> -->
		</TableList>
	</div>
</template>

<script>
	import TableList from "@/components/TableList";
    import { message,Modal } from 'ant-design-vue'
	import {
		getApprovalTransferRecord,
        exportApprovalTransferRecord
	} from "@/api/freezer";

	const columns = [{
			title: "调拨单号",
			dataIndex: "approval_no",
		},
		{
			title: "发起人",
			dataIndex: "username"
		},
		{
			title: "调出部门",
			dataIndex: "department_name"
		},
		{
			title: "调出客户",
			dataIndex: "customer_name"
		},
        {
			title: "调出经销商ID",
			dataIndex: "customer_id"
		},
		{
			title: "资产编号",
			dataIndex: "goods_code"
		},
        {
			title: "型号",
			dataIndex: "goods_model"
		},
		{
			title: "调入部门",
			dataIndex: "transfer_department_name",
		},
		{
			title: "调入经销商",
			dataIndex: "transfer_customer_name"
		},
        {
			title: "调入经销商ID",
			dataIndex: "transfer_customer_id"
		},
        {
			title: "接收时间",
			dataIndex: "receive_date"
		},
		{
			title: "实际接收时间",
			dataIndex: "actual_receive_date"
		},
		// {
		// 	title: "操作",
		// 	dataIndex: "operation",
		// 	scopedSlots: {
		// 		customRender: "operation"
		// 	}
		// }
	];

	export default {
		name: "Index",
		components: {
			TableList
		},
		data() {
			return {
				get_table_list: getApprovalTransferRecord,
				submit_preprocessing: {
					array_to_string: ['department_id']
				},
				columns,
				form_data_seo: {
					...this.$config.form_data_seo,
					list: [
                        {
                            type: "text",
                            name: "keyword",
                            title: "关键词",
                            placeholder: '请输入资产编号、资产型号',
                            options: {}
                        },
                        {
                            type: "tree-select",
                            name: "department_id",
                            title: "发起人部门",
                            options: {},
                            treeData: [],
                            multiple: true
                        }
                    ],
				}
			};
		},
		async created() {
			this.$method.get_department().then(res => {
				this.form_data_seo.list = this.$method.set_form_list(this.form_data_seo.list, 'department_id', 'treeData', res)
			});
		},
		methods: {
            goReport() {
                exportApprovalTransferRecord({
                    data:{
                        export_type:'transfer_binding_record',
                        department_id:this.$refs.list.seo_data.department_id,
                        keyword:this.$refs.list.seo_data.keyword
                    }
                }).then(res=>{
                    message.success(res.info);
                })
            },
		}
	};
</script>

<style lang="less">
	
</style>
